import React from "react";
import NotifInfo from "../Notif-Info/NotifInfo";
import AccountInfoComponent from "../AccountInfo/AccountInfoComponent";
import styled from "styled-components";
import PageInfo from "../Page-Info/PageInfo";

export default function StudentLeftSide() {
  return (
    <LeftElemets>
      <Header>
        <AccountInfoComponent />
        <NotifInfo />
      </Header>
      <PageInfo />
    </LeftElemets>
  );
}

const LeftElemets = styled.div`
  width: 100%;
  height: 100%;
  padding: 15px;
  display: inline-block;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
